import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_conversation_flow_link_RowClass } from "../../../dbschema";

export class BotCfLinkContainerModel extends BaseContainerModel{
  alg_bot_conversation_flow_link: alg_bot_conversation_flow_link_RowClass = new alg_bot_conversation_flow_link_RowClass();
}
